import React, {CSSProperties} from 'react';
import CancelButtonEditor from '../../../cancelButtonEditor/cancelButtonEditor';
import IconsTooltipEditor from '../../../iconsTooltipEditor/iconsTooltipEditor';
import OutlineButtonEditor from '../../../outlineButtonEditor/outlineButtonEditor';
import './headerEditorPanelExercise.scss'
import { useTranslation } from 'react-i18next';

export interface HeaderEditorPanelExerciseProps {
  editState: boolean
  title?: string
  className?: string
  style?: CSSProperties
  hideTitle?: boolean
  hideAddButton?: boolean
  hideSaveButton?: boolean
  hideDeleteButton?: boolean
  hideEditButton?: boolean
  hideViewButton?: boolean
  hideFinishButton?: boolean
  showAddButton?: boolean
  showSaveButton?: boolean
  showDeleteButton?: boolean
  showEditButton?: boolean
  showViewButton?: boolean
  showFinishButton?: boolean
  disableAddButton?: boolean
  disableSaveButton?: boolean
  disableDeleteButton?: boolean
  disableEditButton?: boolean
  disableViewButton?: boolean
  disableFinishButton?: boolean
  textAddButton?: string
  textSaveButton?: string
  textDeleteButton?: string
  textEditButton?: string
  textViewButton?: string
  textFinishButton?: string
  onClickAdd?: ()=>void
  onClickSave?: ()=>void
  onClickDelete?: ()=>void
  onClickEdit?: ()=>void
  onClickView?: ()=>void
  onClickFinish?: ()=>void
}

const HeaderEditorPanelExercise: React.SFC<HeaderEditorPanelExerciseProps> = (props) => {

  const {t} = useTranslation()

  return (
    <div
      className={`header_editor_panel_exercise-layout ${props.className ? props.className : ''}`}
      style={props.style}
    >
      <p>
        {props.title && !props.hideTitle ? props.title : ''}
      </p>
      <div className="container-actions">
        {/* {!props.hideViewButton || props.showViewButton ?
          <IconsTooltipEditor
            text={t('editor.resources.exercise.tooltips.preview_question')}
          >
            <div>
              <OutlineButtonEditor
                type='view'
                className='outline-button'
                onClick={props.onClickView}
              />
            </div>
          </IconsTooltipEditor>
        :null} */}
        {(props.editState && !props.hideDeleteButton) || props.showDeleteButton ?
          <IconsTooltipEditor
            text={props.textDeleteButton ? props.textDeleteButton : t('editor.resources.exercise.tooltips.delete_question')}
          >
            <div>
              <OutlineButtonEditor
                type='delete'
                className='outline-button'
                onClick={props.onClickDelete}
              />
            </div>
          </IconsTooltipEditor>
        :null}
       {(!props.editState && !props.hideEditButton) || props.showEditButton ?
        <IconsTooltipEditor
          text={t('editor.resources.exercise.tooltips.edit_question')}
        >
          <div>
            <OutlineButtonEditor
              type='edit'
              className='outline-button'
              onClick={props.onClickEdit}
            />
          </div>
        </IconsTooltipEditor>
        : null}
        {(props.editState && !props.hideSaveButton) || props.showSaveButton ?
          <IconsTooltipEditor
            text={t('editor.resources.exercise.tooltips.save_changes')}
          >
            <div>
              <OutlineButtonEditor
                type='save'
                className='outline-button'
                onClick={props.onClickSave}
              />
            </div>
          </IconsTooltipEditor>
        : null}
        {!props.hideAddButton || props.showAddButton ?
          <CancelButtonEditor
            onClick={props.onClickAdd}
            style={{backgroundColor: 'var(--primary)', marginLeft: '10px', float: 'right'}}
            disabled={props.disableAddButton}
          >
            {props.textAddButton ? props.textAddButton : t('editor.resources.exercise.tooltips.add')}
          </CancelButtonEditor>
        : null}
        {!props.hideFinishButton || props.showFinishButton ?
          <CancelButtonEditor
            onClick={props.onClickFinish}
            style={{backgroundColor: 'var(--primary)', marginLeft: '10px', float: 'right'}}
            disabled={props.disableFinishButton}
          >
            {t('editor.resources.exercise.tooltips.finish')}
          </CancelButtonEditor>
        : null}
      </div>
    </div>
  );
}

export default HeaderEditorPanelExercise;
